import { FunctionComponent } from "react";

interface AuthTabsProps {
  isSignup: boolean;
  onTabChange: (isSignup: boolean) => void;
}

// [2026-02-06] Auth tabs: Fixed layout to match Figma - tabs centered, full-width underline
const AuthTabs: FunctionComponent<AuthTabsProps> = ({ isSignup, onTabChange }) => {
  return (
    <div className="auth-tabs d-flex mb-4">
      <button
        type="button"
        className={`btn p-0 border-0 bg-transparent signin-tab-label ${
          !isSignup ? "auth-tab-active" : ""
        }`}
        onClick={() => onTabChange(false)}
      >
        Sign in
      </button>
      <button
        type="button"
        className={`btn p-0 border-0 bg-transparent signup-tab-label ${
          isSignup ? "auth-tab-active" : ""
        }`}
        onClick={() => onTabChange(true)}
      >
        Sign up
      </button>
    </div>
  );
};

export default AuthTabs;
